import { Injectable, WritableSignal, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PatientSummaryContent } from '../../models/content/patient-summary-content.model';
import { Patient } from '../../models/patient/patient.model';
import { ContentService } from '../../services/content.service';
import { DataService } from '../../services/data.service';
import { WorkflowService } from '../../services/workflow.service';
import { BreakpointService } from '../../services/breakpoint.service';
import { UserType } from '../../models/enums/user-type.enum';

@Injectable({
  providedIn: 'root',
})
export class PatientSummaryService {
  private _contentService = inject(ContentService);
  private _dataService = inject(DataService);
  private _workflowService = inject(WorkflowService);
  private _breakpointService = inject(BreakpointService);

  getContent(): Observable<PatientSummaryContent> {
    return this._contentService.getPatientSummaryContent();
  }

  getPatient(): WritableSignal<Patient> {
    return this._dataService.patient$;
  }

  getProducts(): WritableSignal<string[]> {
    return this._dataService.products$;
  }

  showPatientSummary(): WritableSignal<boolean> {
    return this._workflowService.showPatientSummary$;
  }

  getIsMobile(): WritableSignal<boolean> {
    return this._breakpointService.isMobileSize;
  }

  getuserType(): WritableSignal<UserType> {
    return this._workflowService.userType$;
  }
}
